<div class="accordion" [class.open]="isOpen()">
  <button class="accordion-header" (click)="onToggle()">
    <div class="accordion-title">
      @if (customIconUrl()) {
        <img [src]="customIconUrl()" class="custom-icon" [style.width]="iconSize()" [style.height]="iconSize()" />
      } @else if (icon()) {
        <app-icon [icon]="$any(icon())" [size]="iconSize()" color="--primary-secondary" />
      }
      <span [style.color]="titleColor() || null">{{ title() }}</span>
    </div>
    <app-icon [icon]="$any(isOpen() ? 'chevron-down' : 'chevron-right')" size="3.5rem" color="--secondary" />
  </button>
  @if (isOpen()) {
    <div class="accordion-content">
      <ng-content />
    </div>
  }
</div>
